<template>
<div>
  <v-content>
    <section>
      <v-parallax :src="require('@/app/assets/images/nature33.jpg')" height="500">
        <v-layout row class="mt-4">

          <div :class="ui.textDisplay1Light">
            {{this.companyTitle2}} plans
          </div>
          <v-spacer/>        
          <div :class="ui.responseShowXs">
            <v-btn flat icon small color="white" :to="'/signup'">
              <v-icon dark>person_add</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/signup'">
              <v-icon dark left>person_add</v-icon>
              sign up
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small :color="ui.btnColorLight" :to="'/legal'">
              <v-icon dark>account_balance</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/legal'">
              <v-icon dark left>account_balance</v-icon>
              legal
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small :color="ui.btnColorLight" :to="'/'">
              <v-icon dark>home</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/'">
              <v-icon dark left>home</v-icon>
              home
            </v-btn>
          </div>
        </v-layout>
      </v-parallax>
      <v-layout row>
        <v-spacer/>
        <div :class="ui.textImage"> Burrup Peninsula </div>
      </v-layout>
    </section>

    <section>
      <v-layout column class="my-5" align-center>
         <v-flex xs12 sm4 class="my-3">
           <div class="text-xs-center">
             <div :class="ui.textHeadline">
               subscription plans
             </div>
           </div>
         </v-flex>
      </v-layout>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm4 md4 lg2 offset-xs0 offset-md0 offset-lg3>
          <InfoCard :info="InfoCard1"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2 >
          <InfoCard :info="InfoCard2"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2>
          <InfoCard :info="InfoCard3"/>
        </v-flex>
      </v-layout>
    </section>

    <v-layout row class="mt-4 mb-4"/>

    <section>
      <v-parallax :src="require('@/app/assets/images/nature29.jpg')" height="600">
        <v-layout row class="mt-4">
          <div :class="ui.textDisplay1Light">
            sign up
          </div>
          <v-spacer/>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small color="white" :to="'/signup'">
              <v-icon dark>person_add</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/signup'">
              <v-icon dark left>person_add</v-icon>
              sign up
            </v-btn>
          </div>
        </v-layout>
      </v-parallax>
      <v-layout row>
        <v-spacer/>
        <div :class="ui.textImage"> Ningaloo Reef, Western Australia </div>
      </v-layout>
    </section>

    <v-container grid-list-xl>
      <v-layout row wrap justify-center class="my-5">
        <v-flex xs12 sm4>
          <v-card class="elevation-0 transparent">
            <v-card-title primary-title class="layout justify-center">
              <div :class="ui.textHeadline">conditions</div>
            </v-card-title>
            <v-card-text :class="ui.textDescription">
              {{this.companyCondition1}}
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card class="elevation-0 transparent">
            <v-card-title primary-title class="layout justify-center">
              <div :class="ui.textHeadline">{{this.companyTitle2}}</div>
            </v-card-title>
            <v-card-text :class="ui.textDescription">
              {{this.companyDescription3}}
            </v-card-text>
            <v-card-text :class="ui.textDescription">
              System {{this.appRevCurrent}}.
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>


    <PublicFooterPage/>

  </v-content>
</div>
</template>


<script>
/* eslint-disable */
import InfoCard from "../components/InfoCard"
import PublicFooterPage from "../components/PublicFooterPage"
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";
import appRevisions from "@/data/globals/mixins/appRevisions.js";

export default {
  components: {
    InfoCard,
    PublicFooterPage
  },
  mixins: [apptheme, publicGlobals, appRevisions],
  data() {
    return {
      currentPagePath: "/about",
      InfoCard1: {
        title: "Free Plan",
        icon: "free_breakfast",
        text: "All new users can enjoy free subscription for 6 months, including all features of the App with some data constraints. Free plan is suitable for small to medium sized businesses."
      },
      InfoCard2: {
        title: "Unlimited $16/mo",
        icon: "emoji_symbols",
        text: "All features of the App with unlimited data transfers, company or facility user access. Subscription service is $16 per month paid monthly and can be cancelled at any time."
      },
      InfoCard3: {
        title: "Enterprise Cloud",
        icon: "account_balance",
        text: "All features described in Unlimited Plan for large business. New enterprise system may require configuration with your business process. Please contact us for consultation and pricing quote."
      }
    };
  }
};
</script>
